import {Box} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/component/Box';

export interface BoxVisitor
{
    onBox(box:Box | null):void;
}

export class BoxTraverser
{
    public static visit(box:Box, visitor:BoxVisitor, reverse:boolean = false, includeYourself:boolean = false)
    {
        if( reverse )
            return BoxTraverser._visitReverse(box, visitor, includeYourself);

        return BoxTraverser._visit(box, visitor, includeYourself);
    }

    private static _visit(box:Box, visitor:BoxVisitor, includeYourself:boolean):void
    {
        if( !box )
            return;

        if( includeYourself )
            visitor.onBox(box);

        for( const child of box.children )
            BoxTraverser._visit(child, visitor, true);
    }

    private static _visitReverse(box:Box, visitor:BoxVisitor, includeYourself:boolean):void
    {
        if( !box )
            return;

        if( includeYourself )
            visitor.onBox(box);

        let parent = box.parent;

        if( parent )
            BoxTraverser._visitReverse(parent, visitor, true);
    }
}
